import React, { useEffect, useState } from 'react';
import { gql, useApolloClient } from '@apollo/client';
import { Button } from 'antd';
import styles from './styles.scss';

const POLL_SERVER_STATUS = gql`
  query ServerStatus {
    serverStatus {
      status
    }
  }
`;

const ReviewConnectionCheck = () => {
  const client = useApolloClient();
  const [status, setStatus] = useState(true);
  const [connected, setConnected] = useState(false);

  const pollStatus = async () => {
    try {
      await client.query({
        query: POLL_SERVER_STATUS,
        fetchPolicy: 'network-only',
      });

      setConnected(true);
      setTimeout(pollStatus, 5000);
    } catch (err) {
      setStatus(false);
      setConnected(false);
      setTimeout(pollStatus, 5000);
    }
  };

  const reloadPage = () => {
    window.location.reload();
  };

  useEffect(() => {
    setTimeout(pollStatus, 5000);
  }, []);

  if (status) return null;

  return (
    <div className={styles.layout}>
      {connected ? (
        <>
          <div className={styles.text}>Internet connection restored.</div>
          <div className={styles.text}>
            Please click the button below to reload the page and resume studying.
          </div>
          <Button onClick={reloadPage}>Continue</Button>
        </>
      ) : (
        <>
          <div className={styles.text}>You're offline!</div>
          <div className={styles.text}>
            Please check your connection. Once we've detected you're back online, this
            screen will update automatically.
          </div>
        </>
      )}
    </div>
  );
};

export default ReviewConnectionCheck;
